import * as Yup from "yup";

export const UpdateAiChatIntialValues = {
    message: ""
  
};

export const getValidationSchema = (variables = []) => {
  let schema = Yup.string().required("Please enter message");

  variables.forEach((v) => {
    if (v.value) {
      schema = schema.test(
        `{{${v.value}}}`,
        `${v.description || v.value} is missing`,
        (value) => value && value.toLowerCase().includes(`{{${v.value}}}`.toLowerCase())
      );
    }
  });
  return Yup.object().shape({
    message: schema,
  });
};
